import type { BannerBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import { EmailPanelImage } from "./email-panel-image";
import { EmailPanelUrl } from "./email-panel-url";
import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import PanelTranslationState from "../../lib/panel/panel-translation-state";

export function BannerEmailPanelRenderer(blockProps: BannerBlockProps) {
  return (
    <PanelContainer blockProps={blockProps}>
      <EmailPanelImage />
      <FloatingPanelSeparator />
      <EmailPanelUrl />
      <PanelTranslationState mode="not-translatable" portal />
    </PanelContainer>
  );
}
